import assert from '@/sui/tools/assert'
import color from 'color'
import css from '@/sui/less/modules.less'

function getHexModuleColor (name, upper = true) {
  const source = css[name]
  assert.notNull(source, 'Invalid module name to get color')
  const hexValue = upper ? source.toUpperCase() : source.toLowerCase()
  const alpha = upper ? 'FF' : 'ff'

  return {
    hex: hexValue,
    hex8: `${hexValue}${alpha}`
  }
}

function getAllModuleColors () {
  const modulesList = [
    'reaInfADI',
    'bactADI',
    'expADI',
    'neoInfADI',
    'diaInfADI',
    'observa4',
    'results',
    'invalid'
  ]

  const result = []
  for (let i = 0; i < modulesList.length; i++) {
    const module = modulesList[i]
    result.push(getHexModuleColor(module))
  }
  return result
}

const additionalColors = {
  indicator: {
    green: { hex: '#00AC1A', hex8: '#00AC1AFF' },
    orange: { hex: '#FF7800', hex8: '#FF7800FF' },
    red: { hex: '#FF0B00', hex8: '#FF0B00FF' }
  },
  participation: {
    low: { hex: '#D6E9F2', hex8: '#D6E9F2FF' },
    medium: { hex: '#007AB0', hex8: '#007AB0FF' },
    high: { hex: '#B00085', hex8: '#B00085FF' },
    unknown: { hex: '#C7C7C7', hex8: '#C7C7C7FF' }
  },
  defaultMapBackgrounds: {
    pellets: { hex: '#25B4F2', hex8: '#25B4F2FF' },
    regions: { hex: '#E8FFFB', hex8: '#E8FFFBFF' }
  }
}

const moduleColors = getAllModuleColors()
const { indicator, participation } = additionalColors
const additionalColorsList = [
  indicator.green, indicator.orange, indicator.red,
  participation.low, participation.medium, participation.high,
  participation.unknown
]

function mixColors (color1, color2, p) {
  const c1 = color(color1)
  const c2 = color(color2)
  const mix = c1.mix(c2, p)
  const hexOpacity =
      (mix.valpha * 255).toString(16).slice(0, 2)
  return `${mix.hex()}${hexOpacity.toUpperCase()}`
}

export default {
  mapPalettes: {
    additionalColors: additionalColors,
    modules: moduleColors,
    extended: [...moduleColors, ...additionalColorsList],
    pellets: [...moduleColors, ...[getHexModuleColor('temporary')]],
    regions: [...[additionalColors.defaultMapBackgrounds.regions], ...moduleColors]
  },

  getHexModuleColor: getHexModuleColor,

  colorSelector: function (v, defaultColor, thresholds, colorGradient) {
    assert(thresholds.length !== 0, `ColorSelector function ranges can't be empty !`)
    const vNum = parseFloat(v)
    const initialThresholdValue = thresholds[0].value
    if (v == null || v === '' || isNaN(vNum) || vNum < initialThresholdValue) {
      return defaultColor.hex8
    }

    for (let i = 0; i < thresholds.length - 1; i++) {
      const threshold = thresholds[i]
      const nextThreshold = thresholds[i + 1]
      const value1 = threshold.value
      const value2 = nextThreshold.value

      if (vNum < value2 && vNum >= value1) {
        const color1 = threshold.color.hex8
        if (colorGradient) {
          const color2 = nextThreshold.color.hex8
          const percent = (vNum - value1) / (value2 - value1)
          return mixColors(color1, color2, percent)
        }

        return color1
      }
    }

    return thresholds[thresholds.length - 1].color.hex8
  }

}
